// ─── Store / Restaurant Endpoints ─────────────────────────────────────────────

// Stores
export const API_GET_STORES_URL = '/store/';
export const API_GET_STORES_BY_ID = '/store/getstorebyId/';
export const API_ADD_STORES = '/store/register/';
export const API_EDIT_STORES = '/store/updatestore/';
export const API_ADD_STORE_BANKAC = '/store/addaccount/';
export const API_ADD_STORE_DOCS = '/store/addStoreDoc/';
export const API_GET_STORE_DOCS = '/store/getStoreDoc/';

// Store Categories
export const API_GET_STORES_CATEGORIES = '/storecategory/';
export const API_GET_STORES_CATEGORIE_BY_ID = '/storecategory/edit/';
export const API_ADD_STORES_CATEGORIE = '/storecategory/add/';
export const API_EDIT_STORES_CATEGORIE = '/storecategory/update';
export const API_DELETE_STORES_CATEGORIE = '/storecategory/remove';
export const API_CATEGORY_ADD_URL = '/category/add';
export const API_CATEGORY_LIST_URL = '/category';
export const API_CATEGORY_GET_URL = '/category/edit';
export const API_CATEGORY_UPDATE_URL = '/category/update';
export const API_CATEGORY_DELETE_URL = '/category/remove';

// Store Items
export const API_GET_STORES_ITEMS = '/store/getAllStoreItem/';
export const API_GET_STORES_ITEM_BY_ID = '/store/getItemById/';
export const API_ADD_STORES_ITEM = '/store/addStoreItem/';
export const API_EDIT_STORES_ITEM = '/store/updateStoreItem';
export const API_DELETE_STORES_ITEM = '/store/deleteStoreItem';
export const API_UPDATE_STORE_ITEM_STATUS = '/store/updateItemStatus';

// Restaurants
export const API_GET_RESTAURANTS_URL = '/admin/getRestaurantWithFilter';
export const API_GET_RESTAURANTS_All = '/admin/restaurantlist';
export const API_RESTAURANTS_VIEW_URL = '/admin/restaurant/';
export const API_RESTAURANTS_DELETE_URL = '/admin/restaurant/remove';
export const API_RESTAURANTS_STATUS_URL = '/admin/restaurantstatus';
export const API_RESTAURANTS_ADD_URL = '/admin/restaurant/add';
export const API_GET_RESTAURANTS_PAYMENTS = '/admin/restaurantpaymentshistory/';
export const API_RESTAURANTS_PAYMENTS = '/admin/paytorestaurant/';

// Cuisines
export const API_CUISINES_LIST_URL = '/admin/cuisines';
export const API_CUISINES_ADD_URL = '/admin/cuisines/add';
export const API_CUISINES_GET_URL = '/admin/cuisines/view';
export const API_CUISINES_UPDATE_URL = '/admin/cuisines/update';
export const API_CUISINES_DELETE_URL = '/admin/cuisines/remove';

// Promotions
export const API_PROMOTIONS_LIST_URL = '/admin/promotions';
export const API_PROMOTIONS_ADD_URL = '/admin/promotions/add';
export const API_PROMOTIONS_GET_URL = '/admin/promotions/view';
export const API_PROMOTIONS_UPDATE_URL = '/admin/promotions/update';
export const API_PROMOTIONS_DELETE_URL = '/admin/promotions/remove';
